import { useEffect, useState } from "react";
import useCountryData from "./useCountryData";

export default function useRatingsCount() {
  const countryData = useCountryData();
  const [ratingsCount, setRatingsCount] = useState("");

  useEffect(() => {
    if (countryData) {
      const rating = countryData.productRatingsCount();
      if (rating) setRatingsCount(rating);
    }
  }, [countryData]);

  return ratingsCount;
}
